// extracted by mini-css-extract-plugin
export var brand = "_35-9";
export var button = "_35-0";
export var chevron = "_35-v";
export var chevronButton = "_35-w";
export var content = "_35-n";
export var danger = "_35-g";
export var dangerOutlined = "_35-h";
export var dark = "_35-l";
export var darkTheme = "_35-c";
export var extraSmall = "_35-4";
export var fullWidth = "_35-8";
export var ghost = "_35-d";
export var gray = "_35-t";
export var icon = "_35-p";
export var iconButton = "_35-s";
export var iconButtonBorder = "_35-x";
export var iconButtonBorderDark = "_35-y";
export var iconButtonBorderLight = "_35-z";
export var iconLeft = "_35-q";
export var iconRight = "_35-r";
export var large = "_35-1";
export var light = "_35-m";
export var medium = "_35-2";
export var micro = "_35-5";
export var nano = "_35-7";
export var outlined = "_35-k";
export var pending = "_35-a";
export var primary = "_35-i";
export var shadow = "_35-o";
export var small = "_35-3";
export var solidLight = "_35-e";
export var solidLightBrand = "_35-f";
export var spinner = "_35-u";
export var transparent = "_35-j";
export var warning = "_35-b";
export var wideNano = "_35-6";